const preprodVersion = '5.0.18';
const prodVersion = '5.0.18';
export const widgetConfig = {
  // Plt
  'cip-cct-consumer-chat-plt': {
    id: 'cip-cct-consumer-chat',
    descriptor: {
      id: 'cip-cct-consumer-chat',
      baseSourceUrl: 'https://uxfabric.intuitcdn.a.intuit.com/cip-cct-consumer-chat',
      widgets: {
        'cip-cct-consumer-chat': {
          '0.1.0': {
            descriptor: `cip-cct-consumer-chat/${preprodVersion}/cip-cct-consumer-chat-component`
          }
        }
      }
    }
  },
  // Dev / qal
  'cip-cct-consumer-chat-qal': {
    id: 'cip-cct-consumer-chat',
    descriptor: {
      id: 'cip-cct-consumer-chat',
      baseSourceUrl: 'https://uxfabric.intuitcdn.a.intuit.com/cip-cct-consumer-chat',
      widgets: {
        'cip-cct-consumer-chat': {
          '0.1.0': {
            descriptor: `cip-cct-consumer-chat/${preprodVersion}/cip-cct-consumer-chat-component`
          }
        }
      }
    }
  },
  // Sys / e2e
  'cip-cct-consumer-chat-sys': {
    id: 'cip-cct-consumer-chat',
    descriptor: {
      id: 'cip-cct-consumer-chat',
      baseSourceUrl: 'https://uxfabric.intuitcdn.a.intuit.com/cip-cct-consumer-chat',
      widgets: {
        'cip-cct-consumer-chat': {
          '0.1.0': {
            descriptor: `cip-cct-consumer-chat/${preprodVersion}/cip-cct-consumer-chat-component`
          }
        }
      }
    }
  },
  // prf
  'cip-cct-consumer-chat-prf': {
    id: 'cip-cct-consumer-chat',
    descriptor: {
      id: 'cip-cct-consumer-chat',
      baseSourceUrl: 'https://uxfabric.intuitcdn.a.intuit.com/cip-cct-consumer-chat',
      widgets: {
        'cip-cct-consumer-chat': {
          '0.1.0': {
            descriptor: `cip-cct-consumer-chat/${preprodVersion}/cip-cct-consumer-chat-component`
          }
        }
      }
    }
  },
  // Prod 
  'cip-cct-consumer-chat-prd': {
    id: 'cip-cct-consumer-chat',
    descriptor: {
      id: 'cip-cct-consumer-chat',
      baseSourceUrl: 'https://uxfabric.intuitcdn.a.intuit.com/cip-cct-consumer-chat',
      widgets: {
        'cip-cct-consumer-chat': {
          '0.1.0': {
            descriptor: `cip-cct-consumer-chat/${prodVersion}/cip-cct-consumer-chat-component`
          }
        }
      }
    }
  },
  // Local
  // 'cip-cct-consumer-chat-local': {
  //   id: 'cip-cct-consumer-chat',
  //   descriptor: {
  //     id: 'cip-cct-consumer-chat',
  //     baseSourceUrl: 'https://uxfabric.intuitcdn.a.intuit.com/cip-cct-consumer-chat',
  //     widgets: {
  //       'cip-cct-consumer-chat': {
  //         '0.1.0': {
  //           descriptor: `cip-cct-consumer-chat/${preprodVersion}/cip-cct-consumer-chat-component`
  //         }
  //       }
  //     }
  //   }
  // }
  // NOTE: Local currently broken
  // // TODO: Figure out how to avoid booting up 2 widgets at once
  // // Local
  // 'cip-cct-consumer-chat-local': {
  //   id: 'cip-cct-consumer-chat',
  //   descriptor: {
  //     id: 'cip-cct-consumer-chat',
  //     baseSourceUrl: 'https://local.intuit.com:3001',
  //     widgets: {
  //       'cip-cct-consumer-chat': {
  //         '0.1.0': {
  //           descriptor: 'cip-cct-consumer-chat/cip-cct-consumer-chat-component'
  //         }
  //       }
  //     }
  //   }
  // }
};
